import { BLAST_STATE_COLORS, BLAST_STATE_LABELS, type EmailBlastState } from '@/types/emailBlast'

interface BlastStateBadgeProps {
  state: EmailBlastState
  className?: string
}

/** Lifecycle pill for an email blast. Color signals progress vs. trouble (see BLAST_STATE_COLORS). */
export function BlastStateBadge({ state, className = '' }: BlastStateBadgeProps) {
  const color = BLAST_STATE_COLORS[state] ?? BLAST_STATE_COLORS.Cancelled
  const label = BLAST_STATE_LABELS[state] ?? state
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color} ${className}`}>
      {label}
    </span>
  )
}
